import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllAddress } from '../../../redux/booking/action'
import "../Report/Report.css"

const UserAddress = ({ userId }) => {
    console.log(userId, "syam")
    const address = useSelector((state) => state?.bookingSlice?.getAddress)
    console.log(address, "address")
    const [params, setParams] = useState({
        page: 1,
        id: userId
    })
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getAllAddress(params))
    }, [dispatch, params])
    return (
        <div className="">
            <div className="sub-head">
                <h4>User Address List</h4>
            </div>

            {/* Table to display address information */}
            <div className="table-category ">
                <div className="table-first-top d-flex justify-content-between align-items-center">
                    
                    <div className="d-flex justify-content-end align-items-center table-right">
                        Filter by
                        <select

                        >
                            <option value="">All</option>
                            <option value="1">Active</option>
                            <option value="2">Inactive</option>
                        </select>
                    </div>
                </div>
                <div className="table-sec table-responsive">
                    <table className="table">
                        <thead className=''>
                            <tr>
                                <th>S. No</th>
                                <th>House/Flat No</th>
                                <th>Apartment/Road Area</th>
                                <th style={{width:'40%'}}>Address</th>
                                <th>Default</th>
                            </tr>
                        </thead>
                        <tbody>
                            {address && address?.addresses?.length > 0 ? (
                                address?.addresses?.map((addr, index) => (
                                    <tr key={addr.id}>
                                        <td>{(index + 1) + ((params?.page - 1) * 10)}</td>
                                        <td>{addr?.house_flat_floor_no}</td>
                                        <td>{addr?.apartment_road_area}</td>
                                        <td>{addr?.address}</td>
                                        <td>{addr.default ? "Yes" : "No"}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6">No addresses found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default UserAddress